import {useQueries} from "@tanstack/react-query";
import userService from "../../../../services/web/user-service.js";

const UseFetchOptions = (valueAsId) => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['nameWar'],
                queryFn: () => userService.getAllNameWar(),
                initialData: []
            },
            {
                queryKey: [valueAsId ? 'userNameId' : 'userName'],
                queryFn: () => valueAsId ? userService.getUsersNamesIds() : userService.getUsersNames(),
                initialData: []
            },
            {
                queryKey: [valueAsId ? 'userLoginId' : 'userLogin'],
                queryFn: () => valueAsId ? userService.getUsersLoginIds() : userService.getUsersLogin(),
                initialData: []
            },
            {
                queryKey: [valueAsId ? 'userCpfId' : 'userCpf'],
                queryFn: () => valueAsId ? userService.getUsersCpfIds() : userService.getUsersCpf(),
                initialData: []
            },
        ]
    });

    return {
        userNameWarOptions: queries[0].data,
        userNameOptions: queries[1].data,
        userLoginOptions: queries[2].data,
        userCpfOptions: queries[3].data
    }
}

export default UseFetchOptions;